.suggestionItem {
  align-items: center;
  color: var(--color-text-neutral);
  display: flex;
  font-size: var(--font-size-body-sm);
  gap: 8px;
  list-style-type: none;
}
